import { render, staticRenderFns } from "./select-camilo-type.vue?vue&type=template&id=5330fe4e"
import script from "./select-camilo-type.vue?vue&type=script&lang=ts"
export * from "./select-camilo-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports